import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    main: {
      marginBottom: '1rem'
    },
    box: {
      display: 'flex',
      justifyContent: 'center',
      padding: '1.5rem'
    },
    title: {
      height: '40px'
    }
  },
  subHeader: {
    main: {
      marginBottom: '1rem'
    },
    box: {
      display: 'flex',
      justifyContent: 'center',
      padding: '1.5rem'
    },
    title: {
      width: '500px',
      display: 'flex',
      justifyContent: 'space-between'
    },
    button: {
      width: '100%',
      height: '40px'
    },
    cardControl: {
      width: '100%',
      height: '100px'
    }
  },
  list: {
    main: {
      padding: '1.5rem'
    },
    col: {
      marginBottom: '1rem'
    },
    box: {
      height: '100px'
    }
  },
  legend: {
    main: {
      marginTop: '1rem'
    },
    box: {
      height: '40px'
    },
    boxTwo: {
      height: '20px'
    }
  }
};

const SkeletonFareCalendarOI = (props) => {
  const [className, style] = useStyles(props);
  const { header, subHeader, list, legend } = styles;
  return (
    <Box className={`${className} fr-skeleton`} style={style} dataTestId="skeletonLowFareCalendar">
      <Row gutters>
        <Col lg="4" style={header.main}>
          <Box className="fr-skeleton-element" style={header.title} />
        </Col>
      </Row>
      <Row gutters>
        <Col style={subHeader.main}>
          <Box className="fr-skeleton-element" style={subHeader.button} />
        </Col>
        <Col style={subHeader.main}>
          <Box className="fr-skeleton-element" style={subHeader.button} />
        </Col>
      </Row>
      <Row gutters>
        <Col lg="5" style={subHeader.main}>
          <Box className="fr-skeleton-element" style={subHeader.cardControl} />
        </Col>
        <Col lg="5" style={subHeader.main}>
          <Box className="fr-skeleton-element" style={subHeader.cardControl} />
        </Col>
        <Col lg="2" style={subHeader.main}>
          <Box className="fr-skeleton-element" style={subHeader.cardControl} />
        </Col>
      </Row>
      <Row gutters>
        <Col lg="2" style={subHeader.main}>
          <Box className="fr-skeleton-element" style={subHeader.button} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={list.main}>
            <Col xs="12" style={list.col}>
              <Box className="fr-skeleton-element" style={list.box} />
            </Col>
            <Col xs="12" style={list.col}>
              <Box className="fr-skeleton-element" style={list.box} />
            </Col>
            <Col xs="12" style={list.col}>
              <Box className="fr-skeleton-element" style={list.box} />
            </Col>
            <Col xs="12" style={list.col}>
              <Box className="fr-skeleton-element" style={list.box} />
            </Col>
            <Col xs="12" style={list.col}>
              <Box className="fr-skeleton-element" style={list.box} />
            </Col>
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col xs="5" style={legend.main}>
          <Box className="fr-skeleton-box" style={legend.boxTwo} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonFareCalendarOI.componentName = 'SkeletonFareCalendarOI';

export default SkeletonFareCalendarOI;
